import React from 'react';
import {userAtom} from '../atoms/userAtom';
import { useAtomValue } from 'jotai';
import Login from './Login';
import Footer from './Footer';
import Top from './Top';
import LoggedIn from './LoggedIn';


const Main = () => {
    const user = useAtomValue(userAtom);
    return <>
    <Top/>
    <div style={{minHeight:200}}>
    {user.loggedIn ? <LoggedIn/> : <Login/>}
    </div>
    <Footer/>
    </>;
}

export default Main;